import { formatters } from './formatters';
import { parsers } from './parsers';
import { FieldConfig } from './useForm';
import { validators } from './validators';

export const field = {
  config: <TValue>(config: FieldConfig<TValue | undefined> = {}) => config,
  parsers,
  formatters,
  validators
};
